
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from './use-toast';

interface CreateBookParams {
  title: string;
  isbn: string;
  publishDate: string;
  authorId: string;
  format?: string;
}

export const useCreateBook = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (bookData: CreateBookParams) => {
      const { data, error } = await supabase
        .from('books')
        .insert({
          title: bookData.title,
          isbn: bookData.isbn,
          publish_date: bookData.publishDate,
          author_id: bookData.authorId,
          format: bookData.format || 'paperback',
        })
        .select()
        .single();

      if (error) {
        toast({
          title: 'Error adding book',
          description: error.message,
          variant: 'destructive',
        });
        throw error;
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['books'] });
      toast({
        title: 'Success',
        description: 'Book has been added successfully.',
      });
    },
  });
};
